import { useContext, useState } from "react";
import { AlertContext } from "../context/AlertContext";
import { domain } from "../consts";
import { validateEmail } from "../utils/validate";
import { SVGS } from ".";
import { ForgotPasswordStrings } from "../consts/strings";

const ForgotPassword = ({ setDisplayComponent, formDisplay }) => {
  const { handleAlert } = useContext(AlertContext);
  const [isLoading, setLoading] = useState(false);
  const [form, setForm] = useState({
    email: "",
  });
  const [formErr, setFormErr] = useState({
    email: false,
    password: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "email") {
      setFormErr((prev) => ({
        ...prev,
        email: !validateEmail(value),
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formErr.email || !form.email.length) {
      handleAlert(ForgotPasswordStrings.emailAddressAlert, "warning");
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(`${domain}/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: form.email }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        handleAlert(ForgotPasswordStrings.serverAlert, "error");
        throw new Error(errorMessage);
      }

      setLoading(false);
      handleAlert(
        ForgotPasswordStrings.resetPasswordEmailSentAlert,
        "info",
        function () {
          setDisplayComponent(formDisplay.login);
        },
      );
    } catch (error) {
      setLoading(false);
      handleAlert(ForgotPasswordStrings.serverAlert, "error");
    }
  };

  return (
    <main className="w-full max-w-md mx-auto p-6">
      <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm    ">
        <div className="p-4 sm:p-7">
          <div className="text-center">
            <h1 className="block text-2xl font-bold text-gray-800  ">
              {ForgotPasswordStrings.header}
            </h1>
            <p className="mt-2 text-sm text-gray-600  ">
              {ForgotPasswordStrings.paragraph}
              <a
                className="cursor-pointer text-teal-600 decoration-2 hover:underline font-medium  :outline-none  :ring-1  :ring-gray-600"
                onClick={() => setDisplayComponent(formDisplay.login)}
              >
                {" "}
                {ForgotPasswordStrings.loginButton}
              </a>
            </p>
          </div>

          <div className="mt-5">
            <form onSubmit={handleFormSubmit} noValidate>
              <div className="grid gap-y-4">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm mb-2  "
                  >
                    {ForgotPasswordStrings.emailAddress}
                  </label>
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="email-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.email && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                  </div>

                  <p
                    className={`${
                      !formErr.email && "hidden"
                    } text-xs text-red-600 mt-2`}
                    id="email-error"
                  >
                    {ForgotPasswordStrings.emailAddressErr}
                  </p>
                </div>

                <button
                  type="submit"
                  className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none  :outline-none  :ring-1  :ring-gray-600"
                  disabled={isLoading}
                >
                  {isLoading
                    ? ForgotPasswordStrings.resetPasswordButtonLoading
                    : ForgotPasswordStrings.resetPasswordButton}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
